import I18n from "shared/i18n"
import routeDefinitions from "shared/route-definitions-play.json"
import RoutesNative from "@kaspernj/api-maker/build/routes-native"

const routes = new RoutesNative({
  getLocale: () => I18n.locale
})

routes.loadRouteTranslations(I18n)
routes.loadRouteDefinitions(routeDefinitions, {localized: true})

export default routes
